<app-goals (goalsChange)="onGoalsChange($event)" [(goals)]="parentComponentGoals"></app-goals>
<app-total-caloric-and-macro-intake [goals]="parentComponentGoals" [mealViewModels]="mealViewModels"></app-total-caloric-and-macro-intake>
<app-meal-card (mealViewModelsChange)="onMealChange($event)" [mealViewModels]="mealViewModels"></app-meal-card>
